/**
 * Notification Helper Utility
 * ============================
 * Provides centralized notification display using translated messages from backend
 * Supports success, error, and info notifications with auto-dismiss
 */

import { toast, Zoom } from 'react-toastify';

/**
 * Show success notification
 * @param {string} message - The message to display
 * @param {object} options - Toast options (position, autoClose, etc.)
 */
export const showSuccessNotification = (message, options = {}) => {
  const defaultOptions = {
    position: 'bottom-left',
    autoClose: 3000,
    transition: Zoom,
    ...options,
  };

  toast.success(message, defaultOptions);
};

/**
 * Show error notification
 * @param {string} message - The message to display
 * @param {object} options - Toast options (position, autoClose, etc.)
 */
export const showErrorNotification = (message, options = {}) => {
  const defaultOptions = {
    position: 'bottom-left',
    autoClose: 3000,
    transition: Zoom,
    ...options,
  };

  toast.error(message, defaultOptions);
};

/**
 * Show info notification
 * @param {string} message - The message to display
 * @param {object} options - Toast options (position, autoClose, etc.)
 */
export const showInfoNotification = (message, options = {}) => {
  const defaultOptions = {
    position: 'bottom-left',
    autoClose: 3000,
    transition: Zoom,
    ...options,
  };

  toast.info(message, defaultOptions);
};

const notificationHelper = {
  showSuccessNotification,
  showErrorNotification,
  showInfoNotification,
};

export default notificationHelper;
